import { Grid, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PaginationType } from 'inside-fifa/api/generic-tables/dto';
import { useFormikContext } from 'formik';
import { UpdateConfigDialogFormValues } from '../../dto';
import { MAX_PAGINATION_SIZE, MIN_PAGINATION_SIZE } from './consts';

export const PaginationManager = () => {
    const { values, isSubmitting, setFieldValue, getFieldProps, touched, errors } =
        useFormikContext<UpdateConfigDialogFormValues>();

    return (
        <Grid container rowGap={3} direction="column">
            <Grid item>
                <Stack spacing={1}>
                    <InputLabel>
                        <FormattedMessage id="inside-fifa.generic-tables.pagination-type" />
                    </InputLabel>
                    <Select<PaginationType>
                        value={values.config.paginationType}
                        onChange={(event) => {
                            const newPaginationType =
                                event.target?.value ?? (PaginationType.Pagination as PaginationType);
                            setFieldValue('config.paginationType', newPaginationType);
                        }}
                    >
                        <MenuItem value={PaginationType.Pagination}>
                            <FormattedMessage id="inside-fifa.generic-tables.pagination-type.pagination" />
                        </MenuItem>
                        <MenuItem value={PaginationType.ShowMoreLess}>
                            <FormattedMessage id="inside-fifa.generic-tables.pagination-type.show-more" />
                        </MenuItem>
                    </Select>
                </Stack>
            </Grid>
            <Grid item>
                <Stack spacing={1}>
                    <InputLabel>
                        <FormattedMessage
                            id={
                                values.config.paginationType === PaginationType.ShowMoreLess
                                    ? 'inside-fifa.generic-tables.initial-items-count'
                                    : 'inside-fifa.generic-tables.items-per-page'
                            }
                        />
                    </InputLabel>
                    <TextField
                        type="number"
                        inputProps={{ min: MIN_PAGINATION_SIZE, max: MAX_PAGINATION_SIZE }}
                        id="itemsPerPage"
                        error={touched.config?.itemsPerPage && Boolean(errors.config?.itemsPerPage)}
                        helperText={touched.config?.itemsPerPage && errors.config?.itemsPerPage}
                        disabled={isSubmitting}
                        {...getFieldProps('config.itemsPerPage')}
                    />
                </Stack>
            </Grid>
        </Grid>
    );
};
